export default "__VITE_ASSET__hjWQ2kES__"